export default {
  userDropDown: {
    userInfo: 'Personal Information',
    changePW: 'Change Password',
    logOut: 'Login Out',
  },
  changePW: {
    changePW: 'Change Password',
    oldPW: 'Old Password',
    newPW: 'New Password',
    confirmPW: 'Confirm New Password',
    change: 'Change',
    cancel: 'Cancel',
  },
};
